























export default {
    name: 'ThePreviewNavBar',
    props: {
        categories: Array,
        restaurant: Object,
    },
    methods: {
        scrollDown() {
            this.$router.push(
                { path: this.$route.fullPath },
                undefined,
                undefined,
            );
        },
    },
};
